<div class="dialog">
  <div class="dialog-background"></div>
  <div class="dialog-content">
    <div class="dialog-close">
      <a (click)="onClose()"><i class="icon-i-close"></i></a>
    </div>
    <h2 class="ui-headline">
      <span class="dialog-title-icon"><span class="icon-i-info"></span></span> {{ 'brokenPrevention.title' | translate }}
    </h2>
    <p>
      <strong>{{ 'brokenPrevention.subtitle' | translate }}</strong>
    </p>
    <p>
      {{ 'brokenPrevention.p1' | translate }}
    </p>
    <p>{{ 'brokenPrevention.p2' | translate }}</p>
    <div class="dialog-buttons">
      <button class="ui-button primary full-width" [class.loading]="undoLoading" type="button" (click)="onUndo()">
        <span class="icon-i-windmill"></span>
        {{ 'brokenPrevention.cta.primary' | translate }}
      </button>
      <button class="ui-button secondary full-width" type="button" (click)="onClose()">
        {{ 'brokenPrevention.cta.secondary' | translate }}
      </button>
    </div>
  </div>
</div>
